import { GET_RIDE_DETAILS, } from "resources/actionTypes";


const initialState = {
  userRideDetails: [],
  loading: false,
  error: null,
};

export function userRideDetails(state =
  initialState, action) {
  switch (action.type) {
    case GET_RIDE_DETAILS.GET_RIDE_DETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RIDE_DETAILS.GET_RIDE_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        userRideDetails: action.userRideDetails
      };
    case GET_RIDE_DETAILS.GET_RIDE_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
